import { Mapper } from 'src/base/mapper'
import { ProductDataTableTypeEntity } from 'src/data/entities/product.entity'
import { ProductDataTableTypeModel } from 'src/domain/models/product.model'

export class ProductDataTableMapper extends Mapper<ProductDataTableTypeEntity, ProductDataTableTypeModel> {
	mapFrom(param: ProductDataTableTypeEntity): ProductDataTableTypeModel {
		return {
			productId: param.productId,
			productName: param.productName,
			numberOfPlans: param.numberOfPlans,
			numberOfAddons: param.numberOfAddons,
			productDescription: param.productDescription,
			isActive: param.isActive,
		}
	}

	mapTo(param: ProductDataTableTypeModel): ProductDataTableTypeEntity {
		return {
			productId: param.productId,
			productName: param.productName,
			numberOfPlans: param.numberOfPlans,
			numberOfAddons: param.numberOfAddons,
			productDescription: param.productDescription,
			isActive: param.isActive,
			productPicture: null,
		}
	}
}
